import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ReceiptTypesSettings } from '@/components/settings/receipt-types-settings';

export function ReceiptTypesPage() {
  return (
    <div className="flex flex-col gap-6 p-4 md:p-6">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold tracking-tight">Receipt Types</h1>
          <p className="text-muted-foreground mt-1 text-sm md:text-base">
            Manage the categories for your receipts
          </p>
        </div>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Receipt Types</CardTitle>
          <CardDescription>
            Manage the categories for your receipts
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ReceiptTypesSettings />
        </CardContent>
      </Card>
    </div>
  );
}
